"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHRandomSeedable = exports.KHRandomGeneral = exports.KHIRandom = void 0;
/**
 * Random value abstract class for wrapping different PRNGs. None of these are
 * secure or completely random. Don't use them for anything that matters.
 */
class KHIRandom {
    /**
     * Returns a random element from the array.
     * @param array
     */
    getRandom(array) {
        return array[this.nextInt(0, array.length)];
    }
    getNRandom(array, count) {
        if (count >= array.length)
            return array;
        return this.shuffledArray(array).slice(0, count);
    }
    /**
     * Copies an array and shuffles it.
     */
    shuffledArray(array) {
        const newArray = [].concat(array);
        this.shuffleArray(newArray);
        return newArray;
    }
    /**
     * Shuffles an array in place.
     * @param array Array to shuffle.
     */
    shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = this.nextInt(0, i + 1);
            [array[i], array[j]] = [array[j], array[i]];
        }
    }
    getNRandomEnum(anEnum, count) {
        const enumValues = this.arrayFromEnum(anEnum);
        return this.getNRandom(enumValues, count);
    }
    getRandomEnum(anEnum) {
        const enumValues = this.arrayFromEnum(anEnum);
        const randomIndex = Math.floor(this.next() * enumValues.length);
        const randomEnumValue = enumValues[randomIndex];
        return randomEnumValue;
    }
    arrayFromEnum(anEnum) {
        return Object.keys(anEnum)
            .map(n => Number.parseInt(n))
            .filter(n => !Number.isNaN(n));
    }
    /**
     * Returns the next random number between [0,1). Either this or
     * nextIntNoRange must be implemented.
     */
    next() {
        return this.nextInt(0, this.maxValue) / this.maxValue;
    }
    nextFloat(min, max) {
        return this.next() * (max - min) + min;
    }
    /**
     * Returns a boolean that is true with a chance of chance.
     * @param chance Number between 0 and 1.
     */
    withChance(chance) {
        return this.next() < chance;
    }
    /**
     * Returns the next boolean.
     */
    nextBoolean() {
        return this.next() >= 0.5;
    }
    /**
     * Returns the next random number between min and max.  Note: This will max out at maxValue, so be aware
     * if you're passing in a larger value.
     * @param min
     * @param maxExclusive
     */
    nextInt(min = 0, maxExclusive = this.maxValue) {
        return (this.nextIntNoRange() % (maxExclusive - min)) + min;
    }
    /**
     * Either this or next must be implemented.
     */
    nextIntNoRange() {
        return Math.floor(this.next() * this.maxValue);
    }
    constructor(seed) {
        if (this.constructor === KHIRandom) {
            throw "Can't instantiate this directly.";
        }
    }
}
exports.KHIRandom = KHIRandom;
class KHRandomGeneral extends KHIRandom {
    constructor(seed) {
        if (seed !== undefined) {
            console.log("KHRandomGeneral does not take a seed.");
        }
        super(0);
        // Can't use max safe integer since that always returns odd numbers.
        // This is good enough.
        this.maxValue = 0xFFFFFFFF;
    }
    next() {
        return Math.random();
    }
}
exports.KHRandomGeneral = KHRandomGeneral;
class KHRandomSeedable extends KHIRandom {
    constructor(seed) {
        super(seed);
        this.maxValue = 0x7FFF;
        this.current = seed;
    }
    nextIntNoRange() {
        const m = 0x41C64E6D;
        const c = 0x3039;
        this.current = (Math.imul(this.current, m) + c) | 0;
        return (this.current >> 10) & this.maxValue;
    }
}
exports.KHRandomSeedable = KHRandomSeedable;
